import { useSearchParams } from '@aviv-unified-frontend/runtime/router';
import { useMemo } from 'react';
import { useAdsContext } from '../contexts/AdsContext';
export function useTargeting({ slotConfig }) {
    const { targeting: { getTargeting }, adsSearchModel, geoHierarchy, searchModel, } = useAdsContext();
    const [searchParams] = useSearchParams();
    return useMemo(() => {
        const internalTestingValue = searchParams.get('testInterne');
        const targeting = getTargeting({
            props: { adsSearchModel, geoHierarchy, searchModel },
            adSlot: slotConfig,
        });
        if (internalTestingValue) {
            targeting.push({ key: 'testInterne', value: internalTestingValue });
        }
        return targeting;
    }, [adsSearchModel, geoHierarchy, searchModel, slotConfig, getTargeting, searchParams]);
}
